import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { InvestmentsDashboardResponse, fetchInvestmentsDashboard } from "@features/investments/api";

export const dashboardQueryKey = ["investments", "dashboard"] as const;

export function useInvestmentsDashboardQuery(): UseQueryResult<InvestmentsDashboardResponse, Error> {
  return useQuery({
    queryKey: dashboardQueryKey,
    queryFn: fetchInvestmentsDashboard,
  });
}
